import { LorebookStatus } from "@next-platform/packages-ts-types";
const isLorebookStatusNeedReview = (status, num_rejected_entries, num_needs_review_entries) => {
    return status === LorebookStatus.NEEDS_REVIEW ||
        (typeof num_rejected_entries === "number" && num_rejected_entries > 0) ||
        (typeof num_needs_review_entries === "number" &&
            num_needs_review_entries > 0)
        ? true
        : false;
};
export default isLorebookStatusNeedReview;
